export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Ricardo P.',
    'Docente de Gestión Ambiental — México D.F., México',
    'Mis alumnos por fin entienden la diferencia entre impactos ambientales, riesgos y estrategias de gestión, y cómo se conectan con sus comunidades. Antes yo misma perdía tiempo buscando cómo explicar correctamente la gestión ambiental. Ahora entro al aula con todo listo.',
  ],
  [
    'MG',
    'Mariana G.',
    'Profesor de Educación Ambiental — Santiago, Chile',
    'Nunca más llegué a una clase sin saber cómo explicar ecosistemas, residuos o sistemas de gestión ambiental. El material hace el trabajo pesado por mí.',
  ],
  [
    'TL',
    'Tomás L.',
    'Docente de Sostenibilidad — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos de gestión ambiental están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'MR',
    'Mariana R.',
    'Docente de Gestión Ambiental | Lima, Perú',
    'El material sobre ecosistemas y servicios ambientales le cambió la cara a mis alumnos. Por fin entienden cómo la naturaleza nos sostiene. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'JC',
    'Jorge C.',
    'Profesor de Educación Ambiental | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto y mis alumnos motivados.',
  ],
  [
    'FG',
    'Fernando G.',
    'Docente de Sostenibilidad | Caracas, Venezuela',
    'Los 100 proyectos ambientales transformaron cómo mis alumnos aprenden. Ahora gestionan residuos en la escuela, conservan la biodiversidad local, y comprenden cómo sus acciones importan. Lo aplican directamente a su realidad. Eso no lo encontré en ningún otro material.',
  ],
  [
    'LM',
    'Laura M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'El kit de evaluación me devolvió el tiempo de clase. Antes perdía mucho tiempo armando exámenes. Ahora tengo todo listo, coherente y vinculado con los contenidos. Mis alumnos saben exactamente qué van a ser evaluados.',
  ],
  [
    'PP',
    'Pablo P.',
    'Profesor de Gestión Ambiental | Quito, Ecuador',
    'Las 100 estrategias de gestión institucional fueron una revelación. Mis alumnos finalmente entienden que la gestión ambiental es posible. Ayudaron a implementar proyectos en nuestra escuela, analizan impactos reales, y ven resultados concretos. Eso cambió completamente su relación con el ambiente.',
  ],
];
